import { getPath } from '../../../pages/Pages';
import { flattenMenusForSearch } from './flattenMenusForSearch';
import type { Menu } from './types';

/**
 * Clave i18n del subtítulo de la página actual, deducida del menú al que
 * pertenece la ruta. Así cada pantalla del menú lleva su subtítulo bajo el
 * título de la cabecera, como en sporttia-competitions, sin tener que tocar
 * cada página.
 *
 * Cuando varias rutas comparten prefijo (/bookings y /booking/schedules) gana la
 * coincidencia más larga.
 */
export function subtitleKeyForPathname(
    menus: Menu[],
    pathname: string,
): string | undefined {
    if (!pathname || pathname === '/') return undefined;

    let bestCaption: string | undefined;
    let bestLength = 0;

    for (const entry of flattenMenusForSearch(menus)) {
        const route = entry.url ?? (entry.path && getPath(entry.path as any));

        if (!route || route === '/' || route.includes(':')) continue;
        if (pathname !== route && !pathname.startsWith(`${route}/`)) continue;

        if (route.length > bestLength) {
            bestLength = route.length;
            bestCaption = entry.caption;
        }
    }

    return bestCaption ? `sidebar.subtitles.${bestCaption}` : undefined;
}
